<template>
  <el-dialog
    title="选择中奖打卡用户"
    :visible.sync="addvisible"
    width="70%"
    append-to-body
  >
    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column prop="id" label="ID"> </el-table-column>

      <el-table-column prop="userId" label="打卡用户ID"> </el-table-column>
      <el-table-column prop="imageUrl" label="打卡图片">
        <template slot-scope="scope">
          <img
              v-for="(p, i) in checkinImageParts(scope.row.imageUrl)"
              :key="i"
              :src="checkinImageSrc(p)"
              alt=""
              class="checkin-thumb"
            />
        </template>
      </el-table-column>
      <el-table-column prop="content" label="打卡文本"> </el-table-column>

       <el-table-column prop="user" label="小红书昵称">
        <template slot-scope="scope">
          {{scope.row.user.xhsName}}
        </template>
      </el-table-column>

       <el-table-column prop="user" label="小红书账号">
        <template slot-scope="scope">
          {{scope.row.user.xhsAccount}}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="打卡时间"> </el-table-column>

      <el-table-column align="center" label="操作" width="300">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleEdit(scope.row)"
            >选择此用户中奖</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <div class="pagtion">
      <Pagination
        v-bind:child-msg="pageparm"
        @callFather="callFather"
      ></Pagination>
    </div>
  </el-dialog>
</template>

<script>
import Pagination from "../../components/Pagination";

export default {
  data() {
    return {
      addvisible: false,
      loading: false, //是显示加载
      title: "",
      listData: [],
      pageparm: {
        pageNum: 1,
        pageSize: 10,
        total: 10,
        status: "1",
        taskId: "",
      },
      prizeBindId: null,
      goodsId: null,
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    checkinImageParts(imageUrl) {
      if (!imageUrl) return [];
      return String(imageUrl)
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
    },
    checkinImageSrc(part) {
      if (!part) return "";
      const p = String(part).trim();
      if (!p) return "";
      if (/^https?:\/\//i.test(p)) return p;
      const base = this.$store.state.fileBaseUrl;
      if (!base || base === false) return p;
      return String(base).replace(/\/?$/, "/") + p.replace(/^\//, "");
    },
    init(prizeBindId, goodsId, taskId) {
      this.prizeBindId = prizeBindId;
      this.goodsId = goodsId;
      this.pageparm.taskId = taskId;
      this.getdata(this.pageparm);
      this.addvisible = true;
    },
    getdata(parameter) {
      this.loading = true;
      this.$request
        .getCheckinAll(parameter)
        .then((res) => {
          this.loading = false;
          console.log(res.data);
          this.listData = res.data.list;
          // // 分页赋值
          this.pageparm.pageNum = res.data.pageNum;
          this.pageparm.pageSize = res.data.pageSize;
          this.pageparm.total = res.data.total;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.pageparm.pageNum = parm.currentPage;
      this.pageparm.pageSize = parm.pageSize;
      this.getdata(this.pageparm);
    },
    //显示编辑界面
    handleEdit: function (row) {
      this.loading = true;
      this.$request
        .addDraw({
          winnerUserId: row.userId,
          prizeBindId: this.prizeBindId,
          goodsId: this.goodsId,
          taskId: this.pageparm.taskId,
        })
        .then((res) => {
          this.loading = false;

          this.$message({
            type: "success",
            message: "保存成功！",
          });
          this.$emit('close')
          this.addvisible = false
        })
        .catch((err) => {
          this.editFormVisible = false;
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.box {
  display: flex;
}

.checkin-img-cell {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: flex-start;
}


.checkin-thumb {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}

.checkin-thumb--lg {
  width: 200px;
  height: 200px;
}
</style>





// WEBPACK FOOTER //
// src/views/tasks/user.vue